// @flow

export const GENERIC_MESSAGES = {
  upselling:
    'Mejora tu plan para acceder a esta funcionalidad y potenciar tu negocio',
  restriction:
    'Esta funcionalidad no está habilitada para tu rol. Contacta al administrador de tu tienda para obtener acceso.',
};

export const FEATURE_ACCESS_ROUTES = {
  tiersList: '/tiers-list',
};
